export default __webpack_public_path__ + "static/media/condition.fa11d75b.PNG";